/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.testimonial-slider' ).length ) {
        $( '.testimonial-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            pagination: false,
            speed: 800,
          } ).mount( {} );

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );
